import {Inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {DOCUMENT} from "@angular/common";

@Injectable({
    providedIn: 'root',
})
export class FaviconService {
    private renderer: Renderer2;

    constructor(rendererFactory: RendererFactory2,
                @Inject(DOCUMENT) private document: Document,) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    changeFavicon(iconUrl: string): void {
        const head = this.document.head;
        let link = head.querySelector('link[rel="icon"]') as HTMLLinkElement;

        if (!link) {
            link = this.renderer.createElement('link');
            this.renderer.setAttribute(link, 'rel', 'icon');
            this.renderer.appendChild(head, link);
        }

        this.renderer.setAttribute(link, 'href', iconUrl);
    }
}
